"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeBucketUnits = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** Period Units to be used in TimeBucketDefinitions,
 * for convenience these have values in Milliseconds, but be warned these are approximate for YEAR and MONTH
 * Usage in bucketing functions based on getTimeBucketStartDateTimeForTimestamp aims to take into account correct variation in YEAR and MONTH
 */
var TimeBucketUnits;
(function (TimeBucketUnits) {
    TimeBucketUnits[TimeBucketUnits["YEAR"] = iotv_v3_types_1.Milliseconds.DAY.valueOf() * 365] = "YEAR";
    TimeBucketUnits[TimeBucketUnits["MONTH"] = iotv_v3_types_1.Milliseconds.DAY.valueOf() * 31] = "MONTH";
    TimeBucketUnits[TimeBucketUnits["DAY"] = iotv_v3_types_1.Milliseconds.DAY.valueOf()] = "DAY";
    TimeBucketUnits[TimeBucketUnits["HOUR"] = iotv_v3_types_1.Milliseconds.HOUR.valueOf()] = "HOUR";
    TimeBucketUnits[TimeBucketUnits["QUARTERHOUR"] = iotv_v3_types_1.Milliseconds.MINUTE.valueOf() * 15] = "QUARTERHOUR";
    TimeBucketUnits[TimeBucketUnits["MINUTE"] = iotv_v3_types_1.Milliseconds.MINUTE.valueOf()] = "MINUTE";
})(TimeBucketUnits || (exports.TimeBucketUnits = TimeBucketUnits = {}));
